<template>
    <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label top_pad_min">
            {{amenity.name}}
        </label>
        <div class="md-layout-item">
            <div class="md-group">
                <md-button class="md-round md-info md-just-icon btn_counter" title="Down"
                           @click="countDown"><md-icon>remove</md-icon></md-button>
                <md-button class="md-round md-info md-just-icon btn_counter" title="Up"
                           @click="countUp"><md-icon>add</md-icon></md-button>
            </div>
            <span class="count">{{ amenity.details.model }}</span>
            <md-field>
                <md-input type="text" v-model="amenity.details.modelText" :placeholder="amenity.details.placeholder" />
                <span class="md-helper-text">{{amenity.details.help}}</span>
            </md-field>
        </div>
    </div>
</template>
<script>
    export default {
        name: "AmenityNumberText",
        props: {
            amenity: null
        },
        methods: {
            countDown() {
                if (this.amenity.details.model > 1) {
                    this.amenity.details.model--;
                }
            },
            countUp() {
                this.amenity.details.model++;
            },
        }
    };
</script>
<style>
   
</style>
